import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'environments/environment';

export const msalInstance: IPublicClientApplication = new PublicClientApplication({
  auth: {
    clientId: `${environment.APP_CLIENT_ID}`,
    authority: `https://login.microsoftonline.com/${environment.APP_TENANT_ID}`,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
});

export function MSALInstanceFactory(): IPublicClientApplication {
  return msalInstance;
}

/**
 * Must complete before the Angular app bootstraps. Without this, components can call
 * MSAL APIs (getActiveAccount, acquireTokenSilent) before initialize() resolves, and a
 * pending redirect response (code= in the URL) can race with route guards/components
 * each independently calling handleRedirectPromise().
 */
export async function initializeMsal(): Promise<void> {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
    return;
  }

  if (!msalInstance.getActiveAccount()) {
    const [firstAccount] = msalInstance.getAllAccounts();
    if (firstAccount) {
      msalInstance.setActiveAccount(firstAccount);
    }
  }
}
